/**
 * Console telemetry sink (PROD-573).
 *
 * Writes the full FHIR AuditEvent envelope to `console.info` with a
 * canonical `[telemetry]` prefix so events are greppable in dev console
 * output and Vitest stdout. This is the always-on default sink; the
 * App Insights sink is added on top once the runtime config provides a
 * connection string.
 *
 * HC5: zero em / en dashes.
 */
import type { TelemetryEnvelope } from '../events';

export interface TelemetrySink {
  /** Stable identifier; tests use it to clear targeted spies. */
  name: string;
  /** Receive a validated envelope and emit it to the underlying transport. */
  emit: (envelope: TelemetryEnvelope) => void;
}

export const consoleSink: TelemetrySink = {
  name: 'console',
  emit(envelope) {
    // `console.info` is the explicit channel; `console.log` is reserved
    // for ad hoc diagnostics that grep filters drop.
    console.info('[telemetry]', envelope);
  },
};
